import React from "react";

export const Footer = () => (
  <div className="yt-footer">
    <div style={{ marginBottom: 4 }}>
      <a href="#">About</a> | <a href="#">Press &amp; Blogs</a> |{" "}
      <a href="#">Copyright</a> | <a href="#">Creators &amp; Partners</a> |{" "}
      <a href="#">Advertising</a> | <a href="#">Developers</a>
    </div>
    <div>
      <a href="#">Terms</a> | <a href="#">Privacy</a> |{" "}
      <a href="#">Safety</a> | <a href="#">Send Feedback</a>
    </div>
    <div style={{ marginTop: 8 }}>
      ©2026 — A retro tribute to YouTube circa 2008. Videos belong to{" "}
      <a href="https://www.youtube.com/@h1t1" target="_blank" rel="noreferrer">
        @h1t1
      </a>
      .
    </div>
  </div>
);
